import React from 'react';
import { Link } from 'react-router-dom';

const LogoutPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex justify-center items-center">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <div className="flex justify-center">
          <img
            src="/images/jack-logo.jpg"
            alt="Jack Logo"
            style={{ maxWidth: '80%', maxHeight: '30%' }}
            className="pb-8"
          />
        </div>
        <h2 className="text-2xl font-bold mb-6">Logged Out</h2>
        <p className="text-gray-600 mb-6">You have successfully logged out.</p>
        <div className="text-center">
          <Link
            to="/login"
            className="text-blue-600 hover:underline"
          >
            Login Again
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LogoutPage;